const ChatCircleLoading = {
  install: (Vue) => {
    Vue.component('ChatCircleLoading', () => {
      return import('./components/CircleLoading.vue')
    })
  }
}

export default ChatCircleLoading
